//counter used for ongoing actions ids
let actionsIndex = 1;

//sets a record for the actionId with a new counter
export function recordUpdate(actionId) {
    return dispatch => {
        let actionIndex = getActionIndex();
        dispatch({
            type: "UPDATE_STARTED",
            payload: {
                actionId,
                actionIndex
            }
        });
        return actionIndex;
    };
}

//check whether an action with the same id but started later is already ongoing
export function isObsoleteUpdate({ actionId = "", actionIndex = 0 } = {}) {
    return (dispatch, getState) => {
        let pendingUpdates = getState()
            .getIn(["actions", "pendingUpdates"])
            .toJS();
        return pendingUpdates[actionId] ? pendingUpdates[actionId] > actionIndex : true;
    };
}

//removes the store reference to the action if its the last action with this actionId
export function finishUpdate({ actionId = "", actionIndex = 0 } = {}) {
    return {
        type: "UPDATE_ENDED",
        payload: {
            actionId,
            actionIndex
        }
    };
}

function getActionIndex() {
    return actionsIndex++;
}
